<template>
<div v-if="showComponent" class="consent">
  <h3 v-if="label !== null ">{{label}}</h3>
  <div v-html="policyText" class="consent__policy-text"></div>
  <div class="consent__options-container" :class="[{ 'consent__options-container--last': isLast, 'consent__options-container--compact': isCompact, 'consent__options-container--extra': showExtraBmwConsents }]">
    <div class="consent__preference consent__preference--pre">
      <!-- Don't show All Option when BMW Extra consents -->
      <div class="consent__options" v-if="showAllOption && !showExtraBmwConsents">
        <label class="consent__label" :for="`${policyTypeName}-optinAll`">All Options</label>
        <div class="consent__values">
          <label class="tla-check" :for="`${policyTypeName}-optinAll`">
            <input class="tla-check__checkbox" type="checkbox" v-model="consentAll" @change="updateConsentOption('OptInAll', consentAll)" :id="`${policyTypeName}-optinAll`"/>
            <div class="tla-check__indicator" :class="{ 'tla-check__indicator--small': isCompact }"></div>
          </label>
        </div>
      </div>
      <div class="consent__options" v-if="showOptInEmail">
        <label class="consent__label" :for="`${policyTypeName}-OptInEmail`">Email</label>
        <div class="consent__values">
          <label class="tla-check" :for="`${policyTypeName}-OptInEmail`">
            <input class="tla-check__checkbox" type="checkbox" v-model="optInData.OptInEmail" @change="updateConsentOption('OptInEmail', optInData.OptInEmail)" :id="`${policyTypeName}-OptInEmail`"/>
            <div class="tla-check__indicator" :class="{ 'tla-check__indicator--small': isCompact }"></div>
          </label>
        </div>
      </div>
      <div class="consent__options" v-if="showOptInPhone">
        <label class="consent__label" :for="`${policyTypeName}-OptInPhone`">Phone</label>
        <div class="consent__values">
          <label class="tla-check" :for="`${policyTypeName}-OptInPhone`">
            <input class="tla-check__checkbox" type="checkbox" v-model="optInData.OptInPhone" @change="updateConsentOption('OptInPhone', optInData.OptInPhone)" :id="`${policyTypeName}-OptInPhone`"/>
            <div class="tla-check__indicator" :class="{ 'tla-check__indicator--small': isCompact }"></div>
          </label>
        </div>
      </div>
      <div class="consent__options" v-if="showOptInSms">
        <label class="consent__label" :for="`${policyTypeName}-OptInSms`">SMS</label>
        <div class="consent__values">
          <label class="tla-check" :for="`${policyTypeName}-OptInSms`">
            <input class="tla-check__checkbox" type="checkbox" v-model="optInData.OptInSms" @change="updateConsentOption('OptInSms', optInData.OptInSms)" :id="`${policyTypeName}-OptInSms`"/>
            <div class="tla-check__indicator" :class="{ 'tla-check__indicator--small': isCompact }"></div>
          </label>
        </div>
      </div>
      <div class="consent__options" :class="{'consent__options--last' : !showExtraBmwConsents}" v-if="showOptInPost">
        <label class="consent__label" :for="`${policyTypeName}-OptInPost`">Post</label>
        <div class="consent__values">
          <label class="tla-check" :for="`${policyTypeName}-OptInPost`">
            <input class="tla-check__checkbox" type="checkbox" v-model="optInData.OptInPost" @change="updateConsentOption('OptInPost', optInData.OptInPost)" :id="`${policyTypeName}-OptInPost`"/>
            <div class="tla-check__indicator" :class="{ 'tla-check__indicator--small': isCompact }"></div>
          </label>
        </div>
      </div>
      <!-- BMW Extra Consents -->
      <div class="consent__options" v-if="showExtraBmwConsents">
        <label class="consent__label" :for="`${policyTypeName}-OptInCar`">In-car</label>
        <div class="consent__values">
          <label class="tla-check" :for="`${policyTypeName}-OptInCar`">
            <input class="tla-check__checkbox" type="checkbox" v-model="optInData.OptInCar" @change="updateConsentOption('OptInCar', optInData.OptInCar)" :id="`${policyTypeName}-OptInCar`"/>
            <div class="tla-check__indicator" :class="{ 'tla-check__indicator--small': isCompact }"></div>
          </label>
        </div>
      </div>
      <div class="consent__options consent__options--last" v-if="showExtraBmwConsents">
        <label class="consent__label" :for="`${policyTypeName}-OptInApp`">Apps of the BMW Group</label>
        <div class="consent__values">
          <label class="tla-check" :for="`${policyTypeName}-OptInApp`">
            <input class="tla-check__checkbox" type="checkbox" v-model="optInData.OptInApp" @change="updateConsentOption('OptInApp', optInData.OptInApp)" :id="`${policyTypeName}-OptInApp`"/>
            <div class="tla-check__indicator" :class="{ 'tla-check__indicator--small': isCompact }"></div>
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script lang='ts'>
import {
  Component, Prop, Vue, Watch
} from 'vue-property-decorator';
import {
  State,
  Getter,
  Action,
  Mutation,
  namespace
} from 'vuex-class';
import ExtraData from '@/models/ExtraData';
import ToggleSwitchComponent from '../ui/ToggleSwitchComponent.vue';
import OptInData from '../../models/OptInData';

const InitialSettingsModule = namespace('initialSettingsModule');
const EnquiryModule = namespace('enquiryModule');

@Component({
  components: {
  'toggle-switch': ToggleSwitchComponent
  }
  })

export default class PresubMultiConsentComponent extends Vue {
  @InitialSettingsModule.Getter public initialSettings;

  @EnquiryModule.Action public submitOptInConsent;

  @Prop({ default: false })
  public isPartner!: boolean;

  @Prop({ default: false })
  public isLast!: boolean;

  @Prop({ default: false })
  public showOptInEmail!: boolean;

  @Prop({ default: false })
  public showOptInPhone!: boolean;

  @Prop({ default: false })
  public showOptInSms!: boolean;

  @Prop({ default: true })
  public showOptInPost!: boolean;

  @Prop({ default: false })
  public showAllOption!: boolean;

  @Prop({ default: null })
  public label!: string;

  @Prop({ default: null })
  public publishedPolicyVersionId!: string;

  @Prop({ default: null })
  public publishedPolicyVersionContent!: string;

  @Prop({
    default: () => []
  })
  public allowedManufacturerIds!: number[];

  @Prop({ default: false })
  public isCompact!: boolean;

  private optInData: OptInData = new OptInData();

  private consentAll: boolean = false;

  private policyText: string = '';

  public updateConsentOption(consentOption: string, value: boolean) {
    if (consentOption === 'OptInAll') {
      if (this.showOptInEmail) {
        this.optInData.OptInEmail = value;
      }

      if (this.showOptInPhone) {
        this.optInData.OptInPhone = value;
      }

      if (this.showOptInSms) {
        this.optInData.OptInSms = value;
      }

      if (this.showOptInPost) {
        this.optInData.OptInPost = value;
      }
    }

    if (
      (consentOption === 'OptInEmail'
        || consentOption === 'OptInPhone'
        || consentOption === 'OptInSms'
        || consentOption === 'OptInPost')
      && value === false
    ) {
      this.consentAll = false;
    }

    if (((this.optInData.OptInEmail && this.showOptInEmail) || !this.showOptInEmail)
        && ((this.optInData.OptInPost && this.showOptInPost) || !this.showOptInPost)
        && ((this.optInData.OptInPhone && this.showOptInPhone) || !this.showOptInPhone)
        && ((this.optInData.OptInSms && this.showOptInSms) || !this.showOptInSms)) {
      this.consentAll = true;
    }

    this.submitOptInConsent(this.optInData);
    this.setExtraBmwConsents();
  }

  public setExtraBmwConsents() {
    if (this.showExtraBmwConsents) {
      this.$store.dispatch('enquiryModule/submitExtraData', new ExtraData('PartnersOptInCar', this.optInData.OptInCar ? 'true' : 'false'));
      this.$store.dispatch('enquiryModule/submitExtraData', new ExtraData('PartnersOptInApp', this.optInData.OptInApp ? 'true' : 'false'));
    }
  }

  public get policyTypeName(): string {
    return `policy-${this.isPartner ? 'partner' : 'tla'}-${this.hasAllowedManufacturers ? this.allowedManufacturerIds.join('-') : 'all'}`;
  }

  public get showExtraBmwConsents(): boolean {
    if (this.hasAllowedManufacturers) {
      // Check if BMW or MINI
      return this.allowedManufacturerIds.includes(7) || this.allowedManufacturerIds.includes(73);
    }

    return false;
  }

  public get hasValidPolicyOverride(): boolean {
    if (this.publishedPolicyVersionId
      && this.publishedPolicyVersionId.length > 0
      && this.publishedPolicyVersionContent
      && this.publishedPolicyVersionContent.length > 0) {
      return true;
    }

    return false;
  }

  public get hasAllowedManufacturers(): boolean {
    return this.allowedManufacturerIds && this.allowedManufacturerIds.length > 0;
  }

  public get currentManufacturerId(): number {
    return this.$store.getters['vehicleModule/currentManufacturerId'];
  }

  public get isAllowedManufacturer(): boolean {
    if (this.hasAllowedManufacturers) {
      return this.allowedManufacturerIds.includes(this.currentManufacturerId);
    }

    return true;
  }

  public get showComponent(): boolean {
    return this.isAllowedManufacturer
      && this.policyText.length > 0;
  }

  @Watch('currentManufacturerId')
  public setDefaultConsent() {
    if (this.showComponent) {
      this.submitOptInConsent(this.optInData);
      this.setExtraBmwConsents();
    }
  }

  public created() {
    if (this.isPartner) {
      this.optInData.PolicyType = 3;

      if (this.hasValidPolicyOverride) {
        this.optInData.PublishedPolicyId = this.publishedPolicyVersionId;
        this.policyText = this.publishedPolicyVersionContent;
      } else {
        this.optInData.PublishedPolicyId = this.initialSettings.partnerMarketingPolicyVersionId;
        this.policyText = this.initialSettings.partnerMarketingPolicyVersionText;
      }
    } else {
      this.optInData.PolicyType = 1;

      if (this.hasValidPolicyOverride) {
        this.optInData.PublishedPolicyId = this.publishedPolicyVersionId;
        this.policyText = this.publishedPolicyVersionContent;
      } else {
        this.optInData.PublishedPolicyId = this.initialSettings.marketingPolicyVersionId;
        this.policyText = this.initialSettings.marketingPolicyVersionText;
      }
    }

    this.setDefaultConsent();
  }
}
</script>
